import { AppEnv } from '@foxbun/lib-goferal-types';

export const APP_ENV = AppEnv.decode(window.process.env as Parameters<typeof AppEnv.decode>[0]);
